interface ContentWrapperProps {
  style?: React.CSSProperties;
  children: React.ReactNode;
}

export const ContentWrapper = ({ style, children }: ContentWrapperProps) => {
  return (
    <>
      <div
        className="content-wrapper"
        style={{
          margin: 'auto',
          width: '100%',
          padding: '50px 15px 15px 15px',
          ...style,
        }}
      >
        {children}
      </div>
      <style>
        {`
          @media (max-width: 768px) {
            .content-wrapper {
              padding-top: 15px !important;
            }
          }
        `}
      </style>
    </>
  );
};
